<template>
  <div class="relative w-full max-w-sm overflow-hidden">
    <nuxt-link target="_blank" :to="config.pntSkillsAtWork" class="block">
      <div class="relative">
        <nuxt-img
          :src="item.imageSrc"
          :alt="item.title"
          class="w-full h-48 object-cover rounded-sm"
        />
        <div class="absolute inset-0 bg-black bg-opacity-50 rounded-sm"></div>
        <div
          class="absolute bottom-16 w-1/2 left-4 text-white text-lg font-bold"
        >
          {{ item.title }}
        </div>
        <div class="absolute bottom-4 right-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="20"
            viewBox="0 0 22 20"
            class="text-white"
          >
            <g transform="translate(-1 -2)">
              <path
                d="M2,3H8a4,4,0,0,1,4,4V21a3,3,0,0,0-3-3H2Z"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              ></path>
              <path
                d="M22,3H16a4,4,0,0,0-4,4V21a3,3,0,0,1,3-3h7Z"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              ></path>
            </g>
          </svg>
        </div>
        <div class="absolute inset-0 flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="59.944"
            height="76.5"
            viewBox="0 0 59.944 76.5"
          >
            <path
              id="play_1_"
              data-name="play (1)"
              d="M5,3,62.944,40.25,5,77.5Z"
              transform="translate(-4 -2)"
              fill="rgba(255,255,255,0.6)"
              stroke="#fff"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            ></path>
          </svg>
        </div>
      </div>
    </nuxt-link>
    <div
      class="text-gray-700 text-sm"
      :class="isMobile ? 'line-clamp-1 pt-2' : 'py-4'"
    >
      {{ item.description }}
    </div>
  </div>
</template>

<script setup>
defineProps({
  item: {
    type: Object,
    required: true,
  },
  isMobile: {
    type: Boolean,
    default: false,
  },
});

const config = useRuntimeConfig().public;
</script>
